import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export const inputsLogin = () => {
  const { t } = useI18n();
  return [
    {
      key: 'email',
      type: 'email',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: 'Email',
      value: '',
      state: null,
      customClass: 'my-2 lg-input shadow-input',
      listenFocus: true,
      listenChange: true,
      preppendClass: 'input-group-prepend shadow-preppend',
      iconLeft: '/icons/user_perfil.svg',
    },
    {
      key: 'password',
      type: 'password',
      validations: {
        rules: { required: true },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: 'Password',
      value: '',
      state: null,
      customClass: 'my-2 lg-input shadow-input input-password',
      listenFocus: true,
      listenChange: true,
      preppendClass: 'input-group-prepend shadow-preppend',
      iconLeft: '/icons/ojo.svg',
    },
  ];
};
export const twoFactorLogin = ()=>{
  const { t } = useI18n();
  return [
    {
      key: 'codeTwoFactor',
      type: 'text',
      validations: {
        rules: {
          required: true,
        },
        messages: {
          required: t('global.es_obligatorio'),
        },
      },
      placeholder: '******',
      value: '',
      state: null,
      customClass: 'my-2 lg-input shadow-input',
      listenFocus: true,
      preppendClass: 'input-group-prepend shadow-preppend',
      iconLeft: '/icons/user_perfil.svg',
    },
  ]
};
